import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import Grid from '../../../../grid/Grid';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import ArrayUtils from '../../../../../modules/ArrayUtils';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

function STLRealEstateDetailedBill(props) {
  const { bill, } = props;

  const billItems = VerticalLabelList.toList({
    'External Account Id': bill.externalAccountId,
    'Due Date': moment(bill.dueDate)
      .utc()
      .format(),
    Paid: bill.paid,
    'Bill Balance': bill.billBalance_value,
    'St. Louis Bill Balance': bill.stlBillBalance_value,
    'Pay It Balance': bill.payItBalance_value,
    'Client Amount Paid': bill.clientAmountPaid_value,
    'New Notification Enabled': bill.newNotificationEnabled,
    'Due Soon Notification Enabled': bill.dueSoonNotificationEnabled,
    'Last Day To Pay Notification Enabled': bill.lastDayToPayNotificationEnabled,
    'Payment Time Zone': bill.paymentTimeZone,
    'Account Id': bill.accountId,
    Id: bill.id,
  });

  const options = {};
  const paymentTransactions = ObjectUtils.formatStringAsJSONArray(bill.paymentTransactions);
  const flatPmtTxns = ArrayUtils.selectivelyFlattenJSONArrayObjects(paymentTransactions);

  options.headerFormatter = object => _.startCase(object.header);

  const paymentTransactionModel = Grid.toModelFromList(flatPmtTxns, options);

  return (
    <div style={{ height: '100%', fontSize: '20px', }}>
      <FieldSet title="Bill Summary">
        <VerticalLabelList items={billItems} />
      </FieldSet>
      <div style={{ paddingTop: '10px', }}>
        <FieldSet title="Payment Transactions">
          <Grid
            headers={paymentTransactionModel.headers}
            rows={paymentTransactionModel.format(paymentTransactions)}
            onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
          />
        </FieldSet>
      </div>
    </div>
  );
}

STLRealEstateDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default STLRealEstateDetailedBill;
